(function () {
  var MAX_FILE_SIZE = 20 * 1024 * 1024;
  var ALLOWED_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png'];
  var DEBUG_PREFIX = '[ORION QUOTE UPLOAD]';

  var debugEnabled = false;
  try {
    debugEnabled = new URLSearchParams(window.location.search).get('orionQuoteUploadDebug') === '1';
  } catch (error) {
    debugEnabled = false;
  }

  function debugLog() {
    if (!debugEnabled) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift(DEBUG_PREFIX);
    console.info.apply(console, args);
  }

  window.OrionQuoteUploadDebug = {
    enable: function () {
      debugEnabled = true;
      console.info(DEBUG_PREFIX, 'debug enabled');
    },
    disable: function () {
      debugEnabled = false;
    },
    isEnabled: function () {
      return debugEnabled;
    },
    init: initAll,
  };

  function formatFileSize(bytes) {
    if (bytes < 1024 * 1024) return Math.max(1, Math.round(bytes / 1024)) + ' Ko';
    return (bytes / (1024 * 1024)).toLocaleString('fr-FR', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }) + ' Mo';
  }

  function getExtension(fileName) {
    var parts = String(fileName || '').toLowerCase().split('.');
    return parts.length > 1 ? parts.pop() : '';
  }

  function fileKey(file) {
    return file ? [file.name, file.size, file.lastModified].join(':') : '';
  }

  function createUploadError(message, details) {
    var error = new Error(message);
    error.details = details || {};
    return error;
  }

  function initUploader(uploader) {
    if (!uploader || uploader.dataset.quoteUploadInitialized === 'true') return;

    var form = uploader.closest('form');
    var dropzone = uploader.querySelector('[data-quote-dropzone]');
    var input = uploader.querySelector('[data-quote-file-input]');
    var selection = uploader.querySelector('[data-quote-file-selection]');
    var fileName = uploader.querySelector('[data-quote-file-name]');
    var fileSize = uploader.querySelector('[data-quote-file-size]');
    var removeButton = uploader.querySelector('[data-quote-file-remove]');
    var errorMessage = uploader.querySelector('[data-quote-upload-error]');
    var statusMessage = uploader.querySelector('[data-quote-upload-status]');
    var urlInput = uploader.querySelector('[data-quote-upload-url]');
    var endpoint = uploader.dataset.uploadEndpoint;
    var shopDomain = uploader.dataset.shopDomain;
    var selectedFile = null;
    var selectedFileValid = true;
    var uploadedFileKey = '';
    var uploadInProgress = false;
    var nativeSubmitInProgress = false;

    if (!form || !dropzone || !input || !selection || !fileName || !fileSize || !removeButton || !errorMessage || !statusMessage || !urlInput) {
      console.error(DEBUG_PREFIX, 'initialization failed: required element missing', { form: form, uploader: uploader });
      return;
    }

    uploader.dataset.quoteUploadInitialized = 'true';
    debugLog('init', { formId: form.id });
    debugLog('form found', form.id);

    function setError(message) {
      errorMessage.textContent = message || '';
      errorMessage.hidden = !message;
      dropzone.classList.toggle('has-error', Boolean(message));
    }

    function setStatus(message) {
      statusMessage.textContent = message || '';
    }

    function setUploadingState(active) {
      form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(function (button) {
        button.disabled = active;
        button.setAttribute('aria-disabled', active ? 'true' : 'false');
      });
      input.disabled = active;
      removeButton.disabled = active;
      uploader.classList.toggle('is-uploading', active);
    }

    function resetUploadedFile() {
      uploadedFileKey = '';
      urlInput.value = '';
      setStatus('');
    }

    function validateFile(file) {
      if (ALLOWED_EXTENSIONS.indexOf(getExtension(file.name)) === -1) {
        return 'Format non accepté. Utilisez un fichier PDF, JPG ou PNG.';
      }
      if (file.size > MAX_FILE_SIZE) {
        return 'Le fichier dépasse la taille maximale autorisée de 20 Mo.';
      }
      return '';
    }

    function showFile(file) {
      selectedFile = file || null;
      resetUploadedFile();

      if (!file) {
        selectedFileValid = true;
        selection.hidden = true;
        fileName.textContent = '';
        fileSize.textContent = '';
        setError('');
        return;
      }

      var validationMessage = validateFile(file);
      selectedFileValid = !validationMessage;
      fileName.textContent = file.name;
      fileSize.textContent = formatFileSize(file.size);
      selection.hidden = false;
      setError(validationMessage);
      debugLog('file selected', { formId: form.id, name: file.name, size: file.size, valid: selectedFileValid });
    }

    function blockShopifySubmit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    function submitToShopify(submitter) {
      uploadInProgress = false;
      nativeSubmitInProgress = true;
      // requestSubmit must receive an enabled submitter. The capture listener
      // immediately locks it again when the intentional Shopify submit fires.
      setUploadingState(false);
      setStatus('Fichier envoyé. Envoi de votre demande…');
      debugLog('Shopify submit', form.id);

      if (submitter && submitter.form === form) {
        form.requestSubmit(submitter);
      } else {
        form.requestSubmit();
      }
    }

    input.addEventListener('change', function () {
      showFile(input.files && input.files[0]);
    });

    removeButton.addEventListener('click', function () {
      input.value = '';
      showFile(null);
      input.focus();
    });

    dropzone.addEventListener('click', function (event) {
      if (event.target.closest('label[for]') || input.disabled) return;
      input.click();
    });

    dropzone.addEventListener('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && !input.disabled) {
        event.preventDefault();
        input.click();
      }
    });

    ['dragenter', 'dragover'].forEach(function (eventName) {
      dropzone.addEventListener(eventName, function (event) {
        event.preventDefault();
        if (!input.disabled) dropzone.classList.add('is-dragging');
      });
    });

    ['dragleave', 'drop'].forEach(function (eventName) {
      dropzone.addEventListener(eventName, function (event) {
        event.preventDefault();
        dropzone.classList.remove('is-dragging');
      });
    });

    dropzone.addEventListener('drop', function (event) {
      if (input.disabled) return;
      var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
      if (file) showFile(file);
    });

    form.addEventListener('submit', function (event) {
      if (nativeSubmitInProgress) {
        setUploadingState(true);
        return;
      }

      if (!selectedFile) {
        debugLog('Shopify submit without file', form.id);
        return;
      }

      // Block Shopify synchronously before any asynchronous upload work starts.
      blockShopifySubmit(event);
      debugLog('submit intercepted', form.id);

      if (!selectedFileValid) {
        setError(validateFile(selectedFile));
        dropzone.focus();
        return;
      }

      if (uploadInProgress) return;

      if (urlInput.value && uploadedFileKey === fileKey(selectedFile)) {
        submitToShopify(event.submitter);
        return;
      }

      if (!endpoint || !shopDomain || !/\.myshopify\.com$/i.test(shopDomain)) {
        setError('Impossible d’envoyer votre fichier. Veuillez réessayer ou choisir un autre fichier.');
        console.error(DEBUG_PREFIX, 'invalid upload configuration', { endpoint: endpoint, shop: shopDomain, formId: form.id });
        dropzone.focus();
        return;
      }

      var submitter = event.submitter;
      var fileForUpload = selectedFile;
      var keyForUpload = fileKey(fileForUpload);
      var uploadData = new FormData();
      uploadData.append('file', fileForUpload);
      uploadData.append('shop', shopDomain);
      var emailInput = form.querySelector('[name="contact[email]"]');
      if (emailInput && emailInput.value) uploadData.append('email', emailInput.value);

      uploadInProgress = true;
      setUploadingState(true);
      setError('');
      setStatus('Envoi du fichier…');
      debugLog('upload starting', { url: endpoint, shop: shopDomain, formId: form.id });

      fetch(endpoint, {
        method: 'POST',
        body: uploadData,
      })
        .then(function (response) {
          debugLog('response status', response.status);
          return response.text().then(function (responseText) {
            var payload = null;
            try {
              payload = responseText ? JSON.parse(responseText) : null;
            } catch (error) {
              payload = null;
            }

            if (!response.ok || !payload || payload.ok !== true || !payload.secureUrl) {
              throw createUploadError('Upload response rejected', {
                url: endpoint,
                status: response.status,
                response: payload || responseText,
              });
            }
            return payload;
          });
        })
        .then(function (payload) {
          urlInput.value = payload.secureUrl;
          uploadedFileKey = keyForUpload;
          debugLog('upload success', { formId: form.id });
          submitToShopify(submitter);
        })
        .catch(function (error) {
          uploadInProgress = false;
          nativeSubmitInProgress = false;
          setUploadingState(false);
          setStatus('');
          setError('Impossible d’envoyer votre fichier. Veuillez réessayer ou choisir un autre fichier.');
          console.error(DEBUG_PREFIX, 'upload failed', {
            url: endpoint,
            status: error && error.details ? error.details.status : undefined,
            response: error && error.details ? error.details.response : undefined,
            error: error,
          });
          dropzone.focus();
        });
    }, true);
  }

  function initAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    if (root.matches && root.matches('[data-quote-upload]')) initUploader(root);
    root.querySelectorAll('[data-quote-upload]').forEach(initUploader);
  }

  function boot() {
    debugLog('module loaded');
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    debugLog('section reload');
    initAll(event.target);
  });
})();
